<template>
  <div class="home">
    <div style="position: fixed;
    width: 100%;
    top: 0;
    z-index: 99;" id="couponcode-list">
    <div class="coupon-code" v-if="salesProducts && couponResponse && couponResponse.length" v-for="coupon in couponResponse" >
      <div class="left-part">
      <p><strong>Rs {{coupon.discountedAmount}}/- OFF</strong> on Min Order <strong>Rs {{coupon.minimumOrderAmount}}</strong>.<br />Valid only for <strong v-if="coupon.paymentMethod === 'COD'">COD Payments</strong>
      <strong v-else-if="coupon.paymentMethod === 'ONLINE'">Online Payments</strong>
      <strong v-else>TODAY</strong>!</p>
    </div>
    <div class="right-part flx">
      <p>
        <input type="text" :value="coupon.couponCode" readonly :id="coupon.couponCode" />
      <br /><span>User Code</span></p>
      <span class="icon" @click="copyTestingCode(coupon.couponCode)"><CopyIcon /></span>
    </div>
    </div>
  </div>
    <section class="main_content">
      <img src="../assets/images/catBargif.gif"  style="width:100%" @click="goToCategoryPage()" v-if="!$route.query.shopid" >
      <div class="home_category" v-if="salesProducts && salesProducts.length > 0">
    <ul class="wrap_listing">
      <li
        class="filter_card new-item-card discount-card"
        :class="{ 'width100': salesProducts.length == 1}"
        v-for="(product, index) in salesProducts"
        :key="index"
      >
      <img src="../assets/images/icons/verified-icon.png" alt="loader" class="mVerified-Icon" v-if="product.sellerLiteDTO.isApproved"/>
      <p class="home-delivery-text-discount" v-if="product.sellerLiteDTO.sellerShopSettingDTO.homeDeliveryAvailable">FREE HOME DELIVERY</p>
        <figure
          class="img_wrapper spinner_wrapper"
          v-lazyload
          v-if="product.displayImage && product.productName"
          @click="goToProductDetail(product.sellerItemRelationshipId)"
         :class="{'height165': parseFloat(product.averageRating) > 0 && parseFloat(product.mrp) > parseFloat(product.sellingPrice)}"
        >
          <ImageSpinner class="image_spinner" />
          <img :data-url="product.displayImage" alt="product" />
        </figure>
        <figure
          class="img_wrapper spinner_wrapper"
          v-else
          @click="goToProductDetail(product.sellerItemRelationshipId)"
        >
          <img src="../assets/images/watermark1.jpg" alt="item" />
        </figure>
        <div class="product_detail">
         <p class="product-name">{{ product.productName }}</p>
          <p class="bought rating" style="display:flex;" v-if="parseFloat(product.averageRating) > 0">
            <star-rating
              :read-only="true"
              :increment="0.01"
              :starSize="10"
              active-color="#138808"
              :rating="Number(product.averageRating)"
              :show-rating="false"
            ></star-rating>
            <span style="padding-left: 4px;"> ({{product.ratingNum}})</span>
          </p>
          <!-- <p class="bought rating" style="display:flex;" v-else-if="!product.averageRating && $store.state.isViewType === 'GRID_VIEW'">
          No ratings yet
          </p> -->
          <div class="my_price_section">
            <span class="my_price" v-if="product.sellingPrice">
              <span class="rupee-font">₹​</span>{{ product.sellingPrice }}
              <span class="sp-badge" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && $store.state.isViewType === 'LIST_VIEW'">Your Price</span>
              </span>
            <span class="selling_price" v-if="product.sellingPriceWithoutDiscount"
              ><span class="rupee-font">₹​</span>​{{ product.sellingPriceWithoutDiscount }}</span
            >
            <span class="selling_price" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPriceWithoutDiscount) && product.mrp"
              ><span class="rupee-font">₹​</span>​{{ product.mrp }}</span
            >
          </div>
           <label class="price-less-tag" v-if="parseFloat(product.mrp) > parseFloat(product.sellingPrice)">{{$t('lessWithXPrice',{lessAmount:Math.round(parseFloat(product.mrp)-parseFloat(product.sellingPrice))})}} </label>
          <p class="bought" style="color: black">
            {{$t('shop')}} -
            <span style="color: green">{{
              product.sellerLiteDTO.storeName
            }}</span>
            <!-- {{$t('peopleHaveBrought')}} -->
          </p>
          
          <p v-if="product.gmallProductId" @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
              <p v-else>
                <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
        </div>
        <p class="special-price">
            Upto {{parseFloat(product.cashBackPer)}}% cashback on friends purchase
        </p>
      </li>
    </ul>
  </div>
      <!-- <div
        :class="{'hideClass' : isDisplay}"
        class="product_listing_detail"
      > -->
        <!-- <div class="discount-kirana-list" v-if="salesProducts.length > 0">
          <div
            ref="container"
            
            v-for="(product,index) in salesProducts"
            :key="index"
           style="box-shadow: 0 2px 8px 0 rgb(0 0 0 / 9%);
    margin-bottom: 8px;"
          >
          <div class="kirana-card">
            <div class="img_wrapper spinner_wrapper" v-lazyload v-if="product.displayImage"  @click="goToProductDetail(product.sellerItemRelationshipId)">
              <ImageSpinner class="image_spinner" />
              <img :data-url="product.displayImage" alt />
            </div>
            <div class="img_wrapper spinner_wrapper" v-else  @click="goToProductDetail(product.sellerItemRelationshipId)">
              <img src="../assets/images/watermark1.jpg" alt="item" />
            </div>
            <div class="kirana-item-detail">
              <p class="product-name">{{product.productName}}</p>
              <div class="price-section">
                <span class="selling-price"><span class="rupee-font">₹​</span>{{product.sellingPrice}}</span>
                <span class="mrp"><span class="rupee-font">₹​</span>​{{product.mrp}}</span>
              </div>
              <p class="special-price">
                  Upto {{parseFloat(product.cashBackPer)}}% cashback on friends purchase
              </p>
            </div>
            </div>
            <div class="action-btn">
              <button type="button" class="orng-btn" @click="goToCashBackTab()" v-if="$cookie.get('version-code') > 100">Get CashBack</button>
              <p v-if="product.gmallProductId" @click="goToProductDetail(product.sellerItemRelationshipId)" class="
              grn-btn">
                <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
              <p v-else class="grn-btn">
                <ListQuantity :dataQuantity="product" @updateCartCount="getUpdatedCartCount"  />
              </p>
            </div>
          </div>
        </div> -->
        <NoDataFound v-if="salesProductStatus" class="no_record" />
        <infinite-loading
          @infinite="getProductsListing"
          spinner="circles"
          :identifier="resetIdentifier"
          :class="{'errorLog' : isErrorLog}"
        >
          <template slot="no-more" v-if="!salesProductStatus" >{{$t('noMoreRecord')}}</template>
        </infinite-loading>

        <div class="cntntLoad" v-if="loading">
          <img src="../assets/images/loader.gif" alt="loader" />
        </div>
      <!-- </div> -->
    </section>
    <div class="cntntLoad" v-if="blankLoad">
        <img src="../assets/images/loader.gif" alt="loader" />
      </div>
  </div>
</template>

<script>
import constant from "../utils/constant";
import ApiCaller from "../utils/apicaller";
import CategoryFilter from "../components/ProductListSection/CategoryFilter";
import CategoryFilterOption from "../components/ProductListSection/CategoryFilterOption";
import ImageSpinner from "../components/Common/ImageSpinner";
import NoDataFound from "../components/Common/NoDataFound";
import YoutubeIcon from "@/components/Icons/YoutubeIcon"
import ListQuantity from "./ListQuantity"
import { mapState, mapMutations, mapGetters } from "vuex";
import types from "../store/types";
import CopyIcon from "@/components/Icons/CopyIcon";
import GreenWhatsappIcon from '../components/Icons/GreenWhatsappIcon.vue';
import StarRating from "vue-star-rating";
export default {
  name: "DiscountKirana",
  watch: {
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    
  },
  components: {
    CategoryFilter,
    CategoryFilterOption,
    ImageSpinner,
    NoDataFound,
    CopyIcon,
    YoutubeIcon,
    ListQuantity,
    GreenWhatsappIcon,
    StarRating
  },
  data() {
    return {
      appliedFilter: false,
      sortProduct: false,
      pageIndex: 0,
      type: "TRENDING",
      salesProducts: [],
      filterProducts: {
      },
      isDisplay: false,
      choosedCatId: 0,
      selectedcategoryName: "",
      isFilterOption: false,
      loading: false,
      noRecord: false,
      salesProductStatus: false,
      sortOption: "ITEM_DATE",
      sortByValue: "DESC",
      resetIdentifier: +new Date(),
      blankLoad: false,
      isErrorLog: false,
      filterMinPrice: null,
      filterMaxPrice: null,
      couponCardHeight: '',
      isTileView: ""
    };
  },
  computed: {
    ...mapState(["savePosition", "saveData"]),
    ...mapGetters(["couponResponse", "cartSize"])
  },
  methods: {
    goToCategoryPage(){
      try {
        JSBridgePlugin.fireEvents("DAILYNEEDTAB_SHRENIBAR_CLICK");
      } catch (err) {
        console.log(err);
      }
      if(this.$route.query.shopid){
        this.$router.push('/category-listing?from=NORMAL' + '&shopid=' + this.$route.query.shopid)
      }else{this.$router.push('/category-listing?from=NORMAL')}
      
    },
    openCouponChannel(){
      try{
        JSBridgePlugin.genericIntentLaunch("https://www.youtube.com/channel/UCM-3he3y7nnnMT17z-6ZrTQ")
      }catch{
        console.log('not allowed on browser')
      }
    },
    goToCashBackTab(){
       try {
            JSBridgePlugin.openCashBackTab();
          } catch (err) {
            console.log(err);
          }
    },
    copyTestingCode(whatsappNumber) {
        let el = document.getElementById(whatsappNumber)
        el.select();
        document.execCommand('copy');
    },
    getUpdatedCartCount(){
      this.$store.commit(types.UPDATE_CART_SIZE, Math.round(parseInt(this.cartSize) + 1));
    },
    ...mapMutations(["setsavePosition"]),
    goBack() {
      if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    viewAllCat() {
      this.isDisplay = true;
    },
    closeAllCatFromHeader(){
      this.isDisplay = false
    },
    closeAllCat() {
      this.isDisplay = false;
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
      this.filterMaxPrice = 1000000;
      this.filterMinPrice = 0;
      this.salesProducts = [];
      this.resetIdentifier +=1;
    },
    getProductByCategory(data) {
      localStorage.removeItem('LandOnCategoryListingPage');
      this.appliedFilter = false;
      this.sortOption = 'ITEM_DATE';
      this.sortByValue = 'DESC';
      this.filterMaxPrice = 1000000;
      this.filterMinPrice = 0;
      this.loading = true;
      this.salesProductStatus = false;
      this.choosedCatId = parseInt(data.categoryId);
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
      this.salesProducts = [];
      this.resetIdentifier +=1;
    },
    sortByPrice(val, sortByValue) {
      localStorage.removeItem('LandOnCategoryListingPage')
      if (this.sortOption == val && this.sortByValue == sortByValue) {
        this.sortProduct = false;
        return;
      } else {
        this.sortOption = val;
        this.sortByValue = sortByValue
        this.loading = true;
        this.pageIndex = 0;
        this.$store.commit("saveCategoriesData", {
          categoriesPageIndex: this.pageIndex
        });
        this.salesProducts = [];
        this.resetIdentifier +=1;
        }
    },
    getAppliedFilterList(data) {
      this.filterMinPrice = data.minPrice
      this.filterMaxPrice = data.maxPrice
      this.appliedFilter = true;
      localStorage.removeItem('LandOnCategoryListingPage')
      this.appliedFilter = true;
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
      this.salesProducts = [];
      this.resetIdentifier +=1;
      this.isDisplay = false;
    },
    getClearFilter(data) {
      localStorage.removeItem('LandOnCategoryListingPage')
      if (data) {
        this.appliedFilter = true;
      } else {
        this.appliedFilter = false;
      }
    },
    goToProductDetail(productSrId) {
       if((this.$route.query.typeOfSource && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier)|| (this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier && this.$route.query.campaignUnitIdentifier)){
         if(this.$route.query.typeOfSource){
           this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.typeOfSource+ '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&shopid=' + this.$route.query.shopid + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier);
         }else if(this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier && this.$route.query.campaignIdentifier){
           this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source+ '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&shopid=' + this.$route.query.shopid + '&campaignUnitIdentifier=' + this.$route.query.campaignUnitIdentifier);
         }
          
        }else if((this.$route.query.typeOfSource && this.$route.query.campaignIdentifier)|| (this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier)){
         if(this.$route.query.typeOfSource){
           this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.typeOfSource+ '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&shopid=' + this.$route.query.shopid);
         }else if(this.$route.query.source === 'ADS_SERVER' && this.$route.query.campaignIdentifier){
           this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source+ '&campaignIdentifier=' +this.$route.query.campaignIdentifier + '&shopid=' + this.$route.query.shopid);
         }
          
        } else if(this.$route.query.shopid && this.$route.query.source){
          this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source + '&shopid=' + this.$route.query.shopid);
        }else if(this.$route.query.shopid){
          this.$router.push("/detail/" + productSrId + '?source=LOCAL91_CATEGORY_BROWSING' + '&shopid=' + this.$route.query.shopid);
        }else if(this.$route.query.source){
          this.$router.push("/detail/" + productSrId + '?source=' + this.$route.query.source);
        }else if(this.$route.query.type === 'MOST_SELLING_PRODUCT'){
          this.$router.push("/detail/" + productSrId + '?source=MOST_SELLING_PRODUCT');
        }else if(this.$route.query.type === 'GMALL_FACTORY_PRODUCTS'){
          this.$router.push("/detail/" + productSrId + '?source=GMALL_FACTORY_PRODUCTS');
        }else if(this.$route.query.type === 'RETAILER_SHOP_ITEM'){
          this.$router.push("/detail/" + productSrId + '?source=LIFESTYLE');
        }
        else{
          this.$router.push("/detail/" + productSrId + '?source=LOCAL91_CATEGORY_BROWSING');
        }
    },
    getSubCategory(){
      ApiCaller(constant.LOCAL_SHOP_URL, "get-category-tree/"+ this.$route.query.parentCatId , "get")
              .then(data => {
      if (
        data.data.childCategories
      ) {
        this.filterProducts = data.data.childCategories;
        this.$store.commit("saveCategoryFilterData", {
          catfilterProdList: this.filterProducts
        });
        
      }
      }).catch(err => {
        this.loading = false;
        console.log(err);
      });
    },
    getProductsListing($state) {
      if(this.couponResponse && this.couponResponse.length){
       var elmnt = document.getElementById("couponcode-list");
          if(elmnt){
            this.couponCardHeight = elmnt.offsetHeight
          }
      }
      this.loading = true;
          let categoryId = 0;
          if (this.type == 'NORMAL') {
              categoryId = categoryId;
            }
            if (this.$store.getters.categoriesPageIndex) {
              this.pageIndex = this.$store.getters.categoriesPageIndex;
            }
            this.$store.commit("saveCatTypeName", {
              catTypeName: this.type
            });    
          if (this.type == "LIFESTYLE"){ 
              if(this.pageIndex > 0){
                localStorage.removeItem('LandOnCategoryListingPage')
              }
                const obj = {
                    pageIndex : this.pageIndex,
                    shopId: this.$route.query.shopid || null, 
                    categoryId : Number(this.choosedCatId) || null, 
                    sortField : this.sortOption, 
                    sortBy : this.sortByValue, 
                    filters : []
                }
                if(this.type == "LIFESTYLE" && Number(this.choosedCatId)){
                    obj.filters.push({
                      filterField : 'IS_RETAILSHOP_PRODUCTS', filterFieldValue : {
                        value : true
                      }
                    },
                    {
                      filterField : 'INSTOCK', filterFieldValue : {
                        value : true
                      }
                    })
                    if(this.filterMinPrice){
                      obj.filters.push({filterField : 'PRICE',
                        filterFieldValue : {
                          value : null, minValue : this.filterMinPrice, maxValue : this.filterMaxPrice
                        }
                      })
                    }
                  }
                // get-products-by-category-and-filters
              ApiCaller(constant.LOCAL_SHOP_URL, "localshop/get-products" , "post", obj , "get")
              .then(data => {                
                this.sortProduct = false;
                if ( data && data.data.productListingDTOs && data.data.productListingDTOs.length > 0) { 
                  this.pageIndex = this.pageIndex + 1;
                  this.salesProducts.push(...data.data.productListingDTOs);
                  this.$store.commit("saveCategoriesData", {
                    categoriesProdList: this.salesProducts,
                    categoriesPageIndex: this.pageIndex
                  });
                  this.loading = false;
                  this.salesProductStatus = false;
                  if(this.$route.query.source === 'LUCKY_WHEEL_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('LUCKY_WHEEL_SCRATCH')
                  }else if(this.$route.query.source === 'DAILY_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('DAILY_LUCKY_SCRATCH')
                  }else if(this.$route.query.source === 'FUTURE_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('FUTURE_LUCKY_SCRATCH')
                  }
                  $state && $state.loaded();
                } else {
                  this.pageIndex = -1;
                  this.loading = false;
                  $state && $state.complete();
                  if(this.$route.query.source === 'LUCKY_WHEEL_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('LUCKY_WHEEL_SCRATCH_NO_ITEMS')
                  }else if(this.$route.query.source === 'DAILY_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('DAILY_LUCKY_SCRATCH_NO_ITEMS')
                  }else if(this.$route.query.source === 'FUTURE_LUCKY_SCRATCH' && localStorage.getItem('LandOnCategoryListingPage')){
                    this.getCategoryTracking('FUTURE_LUCKY_SCRATCH_NO_ITEMS')
                  }
                  if (this.salesProducts.length === 0) {
                    this.salesProductStatus = true;
                  }
                }
              })
              .catch(err => {
                this.loading = false;
                this.isErrorLog = true
                console.log(err);
              });
          }
             
     
      
    },
    getCategoryTracking(sourceValue){
      ApiCaller(
          constant.LOCAL_SHOP_URL,
          'add-user-traking/?orderSourceType=' + sourceValue,
          'post'
        )
        .then((data) => {

        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  mounted() {
    // if(this.$store.state.isViewType){
    //   this.isTileView = this.$store.state.isViewType
    // }else{
     
    // }
     ApiCaller(constant.APP_SETTING_SERVICE_URL, "get-aap-settings" , "get")
      .then(data => {
        this.$store.commit('VIEW_TYPE', data.data[0].designStyle);
        console.log(this.$route.name)
         if(data.data[0].cloudShopUser){
          if(this.$route.path == '/discount-kirana'){
            this.$store.commit('CLOUDSHOP_USER',false);
          }else{
            this.$store.commit('CLOUDSHOP_USER', data.data[0].cloudShopUser);
          }
        }else{
          this.$store.commit('CLOUDSHOP_USER',false);
        }
      })
      .catch(err => {
        console.log(err);
      });
    localStorage.setItem('LandOnCategoryListingPage', true)
    if(this.$route.query.parentCatId)
    // this.getSubCategory()
    this.choosedCatId = Number(this.$route.query.categoryid)
    if (this.$store.getters.catTypeName === this.$route.query.type) {
      
      if (this.$store.getters.catfilterProdList) {
        this.filterProducts = this.$store.getters.catfilterProdList;
      }
      if (
        this.$store.getters.categoriesProdList &&
        this.$store.getters.categoriesProdList.length > 0 &&
        this.$store.getters.categoriesPageIndex
      ) {
        this.salesProducts = this.$store.getters.categoriesProdList;
        this.pageIndex = this.$store.getters.categoriesPageIndex;
        if(this.couponResponse && this.couponResponse.length){
          var elmnt = document.getElementById("couponcode-list");
            if(elmnt){
              this.couponCardHeight = elmnt.offsetHeight
            }
        }
      }
    } else {
      this.pageIndex = 0;
      this.$store.commit("saveCategoriesData", {
        categoriesPageIndex: this.pageIndex
      });
    }
    if (this.salesProducts.length == 0) {
      this.loading = true;
    } else {
      this.loading = false;
    }
    this.pageIndex = 0;
    if (this.$route.query.type && this.$route.query.type != null) {
      this.type = this.$route.query.type;
    } else {
      this.type = "NORMAL";
    }
    
  },
};
</script>
<style lang="scss" scoped>
.productListing .detail_content .bottom_filter .item{
  background: #fff;
  span{
    color: #138808;
    font-weight: 600;
  }
  strong{
    color: #e02020;
  }
  svg {
    path{
      fill: #138808;
    }
  }
}
.productListing .detail_content{
    padding: 40px 0;
}
.productListing .detail_content .main_customHeading.topZero{
  top: 0;
  box-shadow: rgb(0 0 0 / 9%) 0px 2px 8px 0px;
}
.productListing .detail_content .main_customHeading.topHeight{
  top: 44px;
  box-shadow: rgb(0 0 0 / 9%) 0px 2px 8px 0px;
}
.coupon-code{
  background: #042D49;
  color: #fff;
  // font-weight: 600;
  padding: 8px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #000;
    animation: ak 0.2s 1;
    // animation-delay: 5s;
  .left-part{
    width: 60%;
    font-size: 0.75em;
  }
  .right-part{
    width: 40%;
    justify-content: flex-end;
    p{
      padding-right:8px;
      font-size: 0.875em;
          text-align: right;
      input{
        background: none;
    // width: 49%;
    color: #fff;
    font-weight: 600;
        text-align: right;
        overflow: hidden;
    text-overflow: ellipsis;
      }
      span{
        font-weight: normal;
        color: #A3AEB5;
        font-size: 0.75em;
        display: block;
      }
    }
    .icon{
      background: #A3AEB5;
      display: block;
      width: 35px;
      height: 24px;
      padding: 5px;
      border-radius: 50%;
      .st0{fill:none;stroke:#fff;stroke-width:2;stroke-miterlimit:10;}
	    .st1{fill:none;stroke:#fff;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:4.11,4.11;}
    }
  }
}
@keyframes ak {
  0% {
    transform: translateY(-100%);
    opacity: 0;
  }
  100% {
    transform: translateY(0%);
    opacity: 1;
  }
}
p.product-name {
  font-size: 0.87em;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  white-space: nowrap;
  margin-bottom: 5px;
}
.sortOption {
  color: #0091ff;
}
.infinite-status-prompt{
  color: #fff !important;
}
.productListing .detail_content.paddingMore{
      padding-top: 85px;
}
</style>